import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';


export default class SliderBrand {
  constructor(el) {
    this.el = el;
    this.init();
  }

  init() {
    new Swiper(this.el, {
      modules: [Autoplay],
      loop: true,
      spaceBetween: 10,
      slidesPerView: 2,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
      breakpoints: {
        992: {
          slidesPerView: 5,
        },
      },
    });
  }
}
